/**
 * Test if the current env is a dev env.
 * @returns {boolean}
 */
export const isDev = () => !window.location.hostname.startsWith('www.');

/**
 * Breakpoints shared between the js-toolkit ResizeService and Tailwind.
 * Keep in sync with @studiometa/tailwind-config.
 */
export const BREAKPOINTS = /** @type {const} */ ({
  '2xs': '0rem',
  xs: '30rem',
  s: '40rem',
  m: '48rem',
  l: '64rem',
  xl: '80rem',
  '2xl': '96rem',
  '3xl': '120rem',
});

/** @typedef {keyof typeof BREAKPOINTS} Breakpoint */

export default {
  isDev,
};
